var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_469_58669",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    y: 0.335938,
    width: 26.6667,
    height: 26.6667,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_469_58669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72067 20.7369L4.49634 22.9613C4.1801 23.2775 3.8165 23.3485 3.40553 23.1743C2.99455 23.0001 2.78906 22.6891 2.78906 22.2412V6.07887C2.78906 5.51761 2.98351 5.04253 3.3724 4.65365C3.76128 4.26476 4.23636 4.07031 4.79762 4.07031H21.8916C22.4528 4.07031 22.9279 4.26476 23.3168 4.65365C23.7057 5.04253 23.9001 5.51761 23.9001 6.07887V18.7284C23.9001 19.2896 23.7057 19.7647 23.3168 20.1536C22.9279 20.5425 22.4528 20.7369 21.8916 20.7369H6.72067ZM13.3446 17.6386C13.5989 17.6386 13.812 17.5526 13.984 17.3806C14.156 17.2086 14.242 16.9955 14.242 16.7412C14.242 16.487 14.156 16.2738 13.984 16.1018C13.812 15.9298 13.5989 15.8438 13.3446 15.8438C13.0903 15.8438 12.8772 15.9298 12.7052 16.1018C12.5332 16.2738 12.4472 16.487 12.4472 16.7412C12.4472 16.9955 12.5332 17.2086 12.7052 17.3806C12.8772 17.5526 13.0903 17.6386 13.3446 17.6386ZM13.345 13.7711C13.5812 13.7711 13.7791 13.6913 13.9386 13.5316C14.0981 13.3719 14.1779 13.174 14.1779 12.9378V7.89506C14.1779 7.65895 14.098 7.46104 13.9382 7.30134C13.7784 7.14162 13.5804 7.06176 13.3442 7.06176C13.108 7.06176 12.9101 7.14162 12.7506 7.30134C12.5911 7.46104 12.5113 7.65895 12.5113 7.89506V12.9378C12.5113 13.174 12.5912 13.3719 12.751 13.5316C12.9107 13.6913 13.1087 13.7711 13.345 13.7711Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageFeedback);
export default __webpack_public_path__ + "static/media/messageFeedback.545d02b8b05240ef85e348dc6b2252b4.svg";
export { ForwardRef as ReactComponent };